// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__1gcP4","blue1":"icon_blue1__1GalH","white":"icon_white__207vt","grey6":"icon_grey6__20PGg","red4":"icon_red4__X0_P5"};